import request from './request'

export function listProductionOrder(data) {
  return request.post('/production/orders/list', data)
}
export function selectProductionOrder() {
  return request.get('/production/orders/select')
}
export function getProductionOrder(id) {
  return request.get('/production/orders/' + id)
}
export function progressBoard() {
  return request.get('/production/orders/progress-board')
}
export function saveProductionOrder(data) {
  return request.post('/production/orders', data)
}
export function updateProductionOrder(data) {
  return request.post('/production/orders/update', data)
}
export function deleteProductionOrder(ids) {
  return request.post('/production/orders/delete', ids)
}
export function acceptProductionOrder(data) {
  return request.post('/production/orders/accept', data)
}
export function unacceptProductionOrder(data) {
  return request.post('/production/orders/unaccept', data)
}
export function startProductionOrder(data) {
  return request.post('/production/orders/start', data)
}
export function completeProductionOrder(data) {
  return request.post('/production/orders/complete', data)
}
export function cancelProductionOrder(data) {
  return request.post('/production/orders/cancel', data)
}
export function interruptProductionOrder(data) {
  return request.post('/production/orders/interrupt', data)
}
export function resumeProductionOrder(data) {
  return request.post('/production/orders/resume', data)
}
export function abandonProductionOrder(data) {
  return request.post('/production/orders/abandon', data)
}
export function changeProductionOrderDates(data) {
  return request.post('/production/orders/change-dates', data)
}
export function generateOrderTasks(orderId) {
  return request.post('/production/orders/generate-tasks', { orderId })
}
export function costSummary(orderId) {
  return request.post('/production/orders/cost-summary', { orderId })
}
export function costEstimate(orderId) {
  return request.post('/production/orders/cost-estimate', { orderId })
}
export function costSettle(orderId) {
  return request.post('/production/orders/cost-settle', { orderId })
}
export function generateSubproducts(orderId) {
  return request.post('/production/orders/generate-subproducts', { orderId })
}
export function splitProductionOrder(data) {
  return request.post('/production/orders/split', data)
}
